import type { Country } from '@backmarket/http-api'

import { COUNTRIES_WITH_NATIONAL_ID } from '../../constants/nationalId'

export function isNationalIdShownForBilling(country: Country): boolean {
  return COUNTRIES_WITH_NATIONAL_ID.includes(country)
}
